import LandmarksAPI from '../api/landmarksid';
import { delay } from 'redux-saga'
import {all, call, takeLatest, takeEvery, put} from 'redux-saga/effects'
import {
    setApps, 
    addNewApp, 
    setAppOrganizations, 
    sagaLoadAppOrganizations,
} from './actions';

import {setError, resetErrors} from '../errors/actions';

import createHistory from 'history/createHashHistory'

// ACITON NAMES

import {
  SAGA_LOAD_APPS,
  SAGA_CREATE_APP,
  SAGA_DELETE_APP,
  SAGA_LOAD_APP_ORGANIZATIONS,
  SAGA_ADD_ORGANIZATION_TO_APP,
  SAGA_REMOVE_ORGANIZATION_FROM_APP,
}from './actions';

const history = createHistory();

function* getApps() {
  const results = yield call(LandmarksAPI.getApps);

  // Error checking the server response
  if (results.error === null){
    yield put(setApps(results.json.body));
  }else {
    yield put(setError('Error in getting apps'));
    yield call(delay, 4000);
    yield put(resetErrors());
  }
}

function *createApp(action){
  const results = yield call(LandmarksAPI.createApp, action.payload.app);

  if (results.error === null && results.json){
    yield put(addNewApp(results.json.body));
    history.push('/apps/' + results.json.body._id);
  }else{
    yield put(setError('Error in creating app'));
    yield call(delay, 4000);
    yield put(resetErrors());
  }
}

function *deleteApp(action){
  try {
    const results = yield call(LandmarksAPI.deleteApp, action.payload.appId);
  
    if (results.error === null && results.json){
      history.push('/apps');
    }else{
      yield put(setError('Error in deleting the app'));
      yield call(delay, 4000);
      yield put(resetErrors());
    }
  } catch(e) {
    yield put(setError('Error in deleting the app'));
    yield call(delay, 4000);
    yield put(resetErrors());
  }
}

function *loadAppOrganizations(action){
  const results = yield LandmarksAPI.getAppOrganizations(action.payload.appId);
  
  if (results.error === null && results.json){
    yield put(setAppOrganizations(action.payload.appId, results.json.body));
  } else {
    yield put(setError('Error in getting app organizations'));
    yield call(delay, 4000);
    yield put(resetErrors());
  }
}

function *addOrganizationToApp(action){
  const results = yield LandmarksAPI.addOrganizationToApp(action.payload.appId, action.payload.organizationId);

  if (results.error === null && results.json){
    yield put(sagaLoadAppOrganizations(action.payload.appId));
  }
}

function *removeOrganizationFromApp(action){
  const results = yield LandmarksAPI.removeOrganizationFromApp(action.payload.appId, action.payload.organizationId);

  if (results.error === null && results.json){
    yield put(sagaLoadAppOrganizations(action.payload.appId));
  }
}

export default function* appsSaga(){
	yield all([
		takeLatest(SAGA_LOAD_APPS, getApps),
    takeEvery(SAGA_CREATE_APP, createApp),
    takeEvery(SAGA_DELETE_APP, deleteApp),
    takeEvery(SAGA_LOAD_APP_ORGANIZATIONS, loadAppOrganizations),
    takeEvery(SAGA_ADD_ORGANIZATION_TO_APP, addOrganizationToApp),
    takeEvery(SAGA_REMOVE_ORGANIZATION_FROM_APP, removeOrganizationFromApp),
  ]);
}


// WEBPACK FOOTER //
// ./src/apps/sagas.js